// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3G4MA","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__IucFL"};